module.exports = __webpack_public_path__ + "img/christiane-king-working-portrait.7472643.jpg";